import { ref } from 'vue';

export function useInfinite(fetchFn, extraParams = {}) {
    const items = ref([]);
    const loading = ref(false);
    const showRetryButton = ref(false);
    const hasMore = ref(true);
    const page = ref(1);
    const limit = ref(20);
    const searchQuery = ref('');

    const getItems = async (opts = {}) => {
        if (loading.value) return;
        loading.value = true;
        showRetryButton.value = false;
        try {
            const response = await fetchFn({
                pattern: searchQuery.value,
                page: page.value,
                limit: limit.value,
                ...extraParams
            });
            const data = response.data || [];
            if (opts.append) {
                items.value.push(...data);
            } else {
                items.value = data;
            }
            hasMore.value = data.length === limit.value;
            if (data.length > 0) page.value++;
        } catch (e) {
            showRetryButton.value = true;
        } finally {
            loading.value = false;
        }
    };

    const loadMore = async ({ done }) => {
        if (loading.value || !hasMore.value) {
            done('ok');
            return;
        }
        await getItems({ append: true });
        done('ok');
    };

    const reset = () => {
        items.value = [];
        page.value = 1;
        hasMore.value = true;
        showRetryButton.value = false;        
    };

    return {
        items,
        loading,
        showRetryButton,
        hasMore,
        page,
        limit,
        searchQuery,
        getItems,
        loadMore,
        reset
    };
}
